import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

const orderStatusUrl = "/api/v2/orderstatus";

export interface OrderStatusResultModel {
    uri: string;
    id: string;
    erpOrderNumber: string;
    webOrderNumber: string;
    orderDate: string;
    status: string;
    statusDisplay: string;
    customerNumber: string;
    customerSequence: string;
    customerPO: string;
    currencyCode: string;
    currencySymbol: any;
    terms: string;
    shipCode: string;
    salesperson: string;
    btCompanyName: string;
    btAddress1: string;
    btAddress2: string;
    btAddress3: string;
    btAddress4: string;
    billToCity: string;
    billToState: string;
    billToPostalCode: string;
    btCountry: string;
    stCompanyName: string;
    stAddress1: string;
    stAddress2: string;
    stAddress3: string;
    stAddress4: string;
    shipToCity: string;
    shipToState: string;
    shipToPostalCode: string;
    stCountry: string;
    notes: string;
    productTotal: number;
    orderSubTotal: number;
    discountAmount: number;
    orderDiscountAmount: number;
    productDiscountAmount: number;
    shippingAndHandling: number;
    shippingCharges: number;
    handlingCharges: number;
    otherCharges: number;
    taxAmount: number;
    orderTotal: number;
    modifyDate: string;
    requestedDeliveryDateDisplay: any;
    orderLines: OrderLine[];
    orderPromotions: any[];
    shipmentPackages: ShipmentPackage[];
    returnReasons: any[];
    orderHistoryTaxes: any[];
    productTotalDisplay: string;
    orderSubTotalDisplay: string;
    orderTotalDisplay: string;
    orderGrandTotalDisplay: string;
    discountAmountDisplay: string;
    orderDiscountAmountDisplay: string;
    productDiscountAmountDisplay: string;
    taxAmountDisplay: string;
    totalTaxDisplay: string;
    shippingAndHandlingDisplay: string;
    shippingChargesDisplay: string;
    handlingChargesDisplay: string;
    otherChargesDisplay: string;
    canAddToCart: boolean;
    canAddAllToCart: boolean;
    showTaxAndShipping: boolean;
    shipViaDescription: any;
    fulfillmentMethod: string;
    customerVatNumber: string;
    vmiLocationId: any;
    vmiLocationName: any;
    properties: Properties2;
}

export interface OrderLine {
    uri: any;
    id: string;
    productId: any;
    productUri: any;
    mediumImagePath: any;
    altText: any;
    productName: any;
    manufacturerItem: any;
    customerName: any;
    shortDescription: any;
    productErpNumber: string;
    customerProductNumber: string;
    requiredDate: any;
    lastShipDate: any;
    customerNumber: string;
    customerSequence: string;
    lineType: string;
    status: string;
    lineNumber: number;
    releaseNumber: number;
    linePOReference: string;
    description: string;
    warehouse: string;
    notes: string;
    qtyOrdered: number;
    qtyShipped: number;
    unitOfMeasure: string;
    unitOfMeasureDisplay: any;
    unitOfMeasureDescription: any;
    availability: any;
    inventoryQtyOrdered: number;
    inventoryQtyShipped: number;
    unitPrice: number;
    unitNetPrice: number;
    extendedUnitNetPrice: number;
    discountPercent: number;
    discountAmount: number;
    unitDiscountAmount: number;
    promotionAmountApplied: number;
    totalDiscountAmount: number;
    lineTotal: number;
    totalRegularPrice: number;
    unitListPrice: number;
    unitRegularPrice: number;
    unitCost: number;
    orderLineOtherCharges: number;
    taxRate: number;
    taxAmount: number;
    returnReason: any;
    rmaQtyRequested: number;
    rmaQtyReceived: number;
    unitPriceDisplay: string;
    unitNetPriceDisplay: string;
    extendedUnitNetPriceDisplay: string;
    discountAmountDisplay: string;
    unitDiscountAmountDisplay: string;
    promotionAmountAppliedDisplay: string;
    totalDiscountAmountDisplay: string;
    lineTotalDisplay: string;
    totalRegularPriceDisplay: string;
    unitListPriceDisplay: string;
    unitRegularPriceDisplay: string;
    unitCostDisplay: string;
    orderLineOtherChargesDisplay: string;
    costCode: any;
    canAddToCart: boolean;
    isActiveProduct: boolean;
    sectionOptions: any;
    salePriceLabel: any;
    canAddToWishlist: boolean;
    brand: any;
    netPriceWithVat: number;
    netPriceWithVatDisplay: string;
    unitPriceWithVat: number;
    unitPriceWithVatDisplay: string;
    vmiBinNumber: any;
    properties: Properties;
}

export interface Properties {
    qtyBackOrdered: string;
    eta: string;
}

export interface ShipmentPackage {
    id: string;
    shipmentDate: string;
    packageNumber: string;
    carrier: string;
    shipVia: string;
    trackingUrl: string;
    trackingNumber: string;
    packSlip: any;
    shipmentPackageLineDtos: any[];
}

export interface Properties2 {
    invoices: string;
    qtyOrdered: string;
    qtyShipped: string;
    qtyBackOrdered: string;
    emailAddress?: string;
    tracking?: string;
}

export interface OrderStatusParams extends ApiParameter {
    customerNumber: string;
    identifier: string;
}

export async function getOrderStatus(parameter: OrderStatusParams) {
    const response = await get<OrderStatusResultModel | string>(
        `${orderStatusUrl}?parameter.customerNumber=${parameter.customerNumber}&parameter.identifier=${parameter.identifier}
        `,
    );
    return response;
}
